import { GameContextProvider } from "../../contexts/GameContext";
import AdminPanel from "./AdminPanel";
import styled from "styled-components";
import { useContext, useState } from "react";
import { AppContext } from "../../contexts/AppContext";
import { setStyle } from "../../util";
import { EquationsService } from "../../services/equations/equationService";
import { StatusCodes } from "http-status-codes";


const AdminInterface = () => {
    const { defaultValues, setDefaultValues } = useContext(AppContext);
    const [forceRefresh, setForceRefresh] = useState<boolean>(true);

    async function refreshGame() {
        setForceRefresh(!forceRefresh)
        console.log(defaultValues)
        const res = await EquationsService.getGlobalDefaultValues();
            if (res.status === StatusCodes.OK) {
                setDefaultValues(res.data);
                setStyle(res.data)
            }
    }

    return (
        <Container>
            <GameContextProvider>
                <AdminPanel refreshGame={refreshGame}/>
            </GameContextProvider>
        </Container>
    );
};


const Container = styled.div`
    display: flex;
    flex-direction: column;
`


export default AdminInterface;